import { firebase, StateUtils } from 'utils';

const AUTH = 'Auth';
const tag = StateUtils.actionType(AUTH);

export const AUTH_ERROR = tag`AUTH_ERROR`;
export const AUTH_USER = tag`AUTH_USER`;
export const SIGN_OUT = tag`SIGN_OUT`;
export const SIGNING_IN = tag`SIGNING_IN`;

export interface Auth {
  isSignedIn: boolean;
  isSigningIn: boolean;
  authToken: string;
  errorMessage: string;
  user: firebase.UserInfo | null;
}

interface PayloadAuthentication {
  user: firebase.UserInfo;
  authToken: string;
}

export interface ActionType {
  type: string;
  payload?: PayloadAuthentication | {};
}
